document.addEventListener("DOMContentLoaded", () => {  
  const fixedLivePreview = () => {  
    const galleryWrapperSelector = ".grid__item.product__media-wrapper";  
    const $gallery = document.querySelector(galleryWrapperSelector);  

    if (!$gallery) {  
      return;  
    }  

    const style = document.createElement("style");  
    style.innerHTML = `
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-gallery-content {
        background: #fff;
        box-shadow: 0 2px 5px 3px rgba(0, 0, 0, .15);
        display: flex;
        justify-content: center;
        left: 0;
        position: fixed;
        top: 0;
        width: calc(100vw);
        z-index: 99;
      }
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-gallery {
        width: auto;
        zoom: .7;
      }
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-thumbnails,
      .gallery--sticky:not(.gallery--sticky--hide) ${galleryWrapperSelector} .tee-slider__dots {
        display: none;
      }
      .gallery--sticky:not(.gallery--sticky--hide) .gallery--close-button {
        display: block;
      }
      .sticky-gallery-button {
        background-color: #fff;
        display: none;
        position: fixed;
        right: 20px;
        top: 100px;
        z-index: 999;
      }
    `;

    document.head.appendChild(style);

    window.addEventListener("scroll", () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 150) {
        document.body.classList.add("gallery--sticky");
      } else {
        document.body.classList.remove("gallery--sticky");
      }
    });
  };

  const w = window.innerWidth;
  const h = window.innerHeight;

  if (h / w > 1.5 && w < 768) {
    setTimeout(function () {
      fixedLivePreview();
    }, 2000);
  }
});
